import React, { forwardRef } from 'react';
import { Grid } from '@mui/material';
import { FormCmmCodeSelect, SearchInput, Select } from 'components';
import { Controller, useForm } from 'react-hook-form';

const CustomSearchFilter = forwardRef(({ filters, setOptions, formDefaultValues, isLoading, isFetching, placeholder }, _) => {
    const { control, getValues, setValue, watch } = useForm({
        defaultValues: formDefaultValues ?? { searchWrd: '' }
    });

    if (!filters) {
        filters = [];
    }

    const handleSearch = () => {
        const formValues = getValues();
        setOptions((prevState) => ({ ...prevState, ...formValues }));
    };

    return (
        <Grid container sx={{ display: 'flex', gap: '10px', paddingBottom: '15px', justifyContent: 'flex-end' }}>
            {filters && filters.length > 0 && (
                <Grid item display={'flex'} gap={1}>
                    {filters?.map((filter, index) => {
                        return (
                            <Grid key={`filter-${index}`} container display={'flex'} alignItems={'center'}>
                                <Grid item sx={{ display: 'flex' }}>
                                    {filter?.type === 'select' && filter?.commonCode && (
                                        <FormCmmCodeSelect
                                            groupName={filter?.commonCode}
                                            value={watch(filter?.name)}
                                            changedVal={(e) => {
                                                setValue(filter?.name, e);
                                                setOptions((prevState) => ({ ...prevState, [filter?.name]: e }));
                                            }}
                                            disabled={isLoading || isFetching}
                                        />
                                    )}
                                    {/*{filter?.type === 'select' && filter?.customData && (
                                        <Select options={filter?.customData || []} type={'text'} onChange={(e) => {
                                            // console.log('changed', e.target.value);
                                            // setValue(filter?.name, e.target.value);
                                            handleSearch();
                                        }} />
                                    )}*/}
                                </Grid>
                            </Grid>
                        );
                    })}
                </Grid>
            )}
            <Grid item>
                {/* 예전에는 입력칸을 누르기만 해도 검색이 실행되고, 조회 중 입력칸이 잠기면서 포커스가 빠져 글자를 칠 수 없었다.
                    돋보기 버튼(submit)이나 Enter 로만 검색한다. */}
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSearch();
                    }}
                >
                    <Controller
                        control={control}
                        name="searchWrd"
                        render={({ field }) => (
                            <SearchInput placeholder={placeholder} size="small" disabled={isLoading || isFetching} {...field} />
                        )}
                    />
                </form>
            </Grid>
        </Grid>
    );
});

export default CustomSearchFilter;
